export class DynamicDisplayResultModel {
    constructor(translation, angel, behaviorType) {
        this.translation = translation;
        this.angel = angel;
        this.behaviorType = behaviorType;
    }
}
